module.exports = __webpack_public_path__ + "media/src/images/zu_exp_02-0ed3e2afb1e49e54efd2c2de84fd76d1.png";